import { createSelector } from 'reselect'

const getTeacherType = me => me.account.teacher_type
const getSchool = createSelector([getTeacherType], teacher => teacher.school)
const getSchoolId = createSelector([getSchool], school => school.id)

export { getSchool, getSchoolId }
